import script from "./Wallet.vue?vue&type=script&setup=true&lang=ts"
export * from "./Wallet.vue?vue&type=script&setup=true&lang=ts"

import "./Wallet.vue?vue&type=style&index=0&id=1e756969&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e756969"]])

export default __exports__